import React, { useState } from 'react';
import Label from '@components/block-label';
import './editor.scss';

const {
  blockEditor: { InspectorControls, useBlockProps, InnerBlocks },
  element: { useEffect },
  components: { TabPanel, PanelBody, Panel, ToggleControl },
  i18n: { __ },
} = wp;

const Edit = (props) => {
  const { attributes, setAttributes } = props;
  const { activeTab, showGatedContent, label } = attributes;
  const blockProps = useBlockProps();
  const [initialTabName] = useState(() => {
    return showGatedContent ? 'gated' : 'ungated';
  });

  useEffect(() => {
    if (initialTabName !== activeTab) {
      setAttributes({ activeTab: initialTabName });
    }
  }, []); //eslint-disable-line
  const innerBlockProps = {
    template: [['b3rg/ungated-content'], ['b3rg/gated-content']],
    templateLock: 'all',
  };

  const onTabSelect = (activeTab) => {
    setAttributes({ activeTab });
  };

  const onToggleChange = (showGatedContent) => {
    setAttributes({
      showGatedContent,
    });
  };

  return (
    <div {...blockProps} key={blockProps.id}>
      <InspectorControls>
        <Panel>
          <Label {...{ label, setAttributes }} />
          <PanelBody>
            <ToggleControl
              label={__('Enable Gated Content', 'b3rg')}
              checked={showGatedContent}
              onChange={onToggleChange}
            />
          </PanelBody>
        </Panel>
      </InspectorControls>
      <div className="content-gater-tabs">
        <TabPanel
          activeClass="bs-active-tab"
          orientation="horizontal"
          initialTabName={
            initialTabName !== activeTab ? initialTabName : activeTab
          }
          onSelect={onTabSelect}
          tabs={[
            {
              name: 'ungated',
              title: __('Post Content', 'b3rg'),
              className: `tab-ungated`,
            },
            {
              name: 'gated',
              title: __('Gated Content', 'b3rg'),
              className: `tab-gated ${!showGatedContent && 'tab-disabled'}`,
            },
          ]}
        >
          {(tab) => (
            <PanelBody>
              <div className={`${tab.className} bs-active`}>
                <InnerBlocks {...innerBlockProps} />
              </div>
            </PanelBody>
          )}
        </TabPanel>
      </div>
    </div>
  );
};

export default Edit;
